var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page page-listone"},[_c('Menu',{attrs:{"title":"执法信息查询","home":true}}),_c('div',{staticClass:"container-flex wrap-list"},[_c('div',{staticClass:"right-con"},[_c('iframe',{staticClass:"iframe",attrs:{"id":"iframeId","src":_vm.url,"frameborder":"0","scrolling":"auto"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }